/**
 * Centralized typography scale.
 * Use these constants in StyleSheet definitions to keep type hierarchy consistent.
 */

export const fontSize = {
  xs: 11,    // Badges, tiny labels
  sm: 12,    // Meta text, timestamps, caption
  base: 14,  // Secondary body text
  body: 15,  // Primary body text
  md: 16,    // Subheadings, card field labels
  lg: 18,    // Section headings, empty state titles
  xl: 20,    // Card titles, list item headings
  xxl: 24,   // Screen titles
  hero: 28,  // Hero / display text
} as const;

export const fontWeight = {
  regular: '400' as const,
  medium: '500' as const,
  semibold: '600' as const,
  bold: '700' as const,
} as const;

export const letterSpacing = {
  tight: -0.3,  // Large headings — pulls glyphs together for a refined look
  normal: 0,
  wide: 0.4,    // Button labels, all-caps labels
} as const;
